import axios from "axios";
import qs from "qs";

//会以列表
export interface RecordingListItem {
    id: string;
    meetingId: string;
    name: string;
    url: string;
    fileKey: string;
}
export interface GetMeetingListItemData {
    id: string;
    weekTimeId: string;
    text: string;
    url: string;
    title: string;
    time: string;
    status: string;
    type: string;
    teacherNo: string;
    batchNo: string;
    customerCode: string;
    courseNo: string;
    courseSeq: string;
    recordingList: RecordingListItem[];
}
export function getMeetingList(params: { weekTimeId: number }) {
    return axios
        .get<SuccessData<GetMeetingListItemData[]>>(
            `/teacher/livePlatform/getMeetingList`,
            { params }
        )
        .then(res => res.data.data);
}

//会议详情
export function getMeetingDetail(params: { id: string }) {
    return axios
        .get<SuccessData<GetMeetingListItemData>>(
            `/teacher/livePlatform/getMeetingDetail`,
            { params }
        )
        .then(res => res.data.data);
}

//保存修改会议，有id修改，无id新增
export interface EditMeetingProps {
    weekTimeId: number;
    text: string; //文本
    title: string; //标题
    url: string; //url
    time: string; //会议时间
    id?: string;
}
export function saveMeeting(data: EditMeetingProps) {
    return axios
        .post(`/teacher/livePlatform/saveMeeting`, qs.stringify(data))
        .then(res => res.data.data);
}

//删除会议
export function deleteMeeting(data: { id: string }) {
    return axios
        .post(`/teacher/livePlatform/deleteMeeting`, qs.stringify(data))
        .then(res => res.data.data);
}

//保存回放记录 有id修改，无id新增
export interface SaveMeetingData {
    meetingId: string;
    name: string;
    fileKey: string;
    id?: string;
}
export function saveMeetingRecording(data: SaveMeetingData[]) {
    return axios
        .post(`/teacher/livePlatform/saveMeetingRecording`, data)
        .then(res => res.data.data);
}

//删除回放记录
export function deleteMeetingRecording(data: { id: string }) {
    return axios
        .post(
            `/teacher/livePlatform/deleteMeetingRecording`,
            qs.stringify(data)
        )
        .then(res => res.data.data);
}

export enum MeetingType {
    Tencent
}
export function streamPipe(str: string, type: MeetingType) {
    switch (type) {
        case MeetingType.Tencent:
            const TitleRegex = /会议主题：(.*?)\n/;
            const TitleMatch = str.match(TitleRegex);

            const TimeRegex = /会议时间：(.*?)\s+\(GMT\+08:00\)/;
            const TimeMatch = str.match(TimeRegex);

            const UrlRegex = /(https?:\/\/[^\s]+)/g;
            const UrlMatch = str.match(UrlRegex);

            if (TitleMatch && TimeMatch && UrlMatch) {
                const title = TitleMatch[1];
                const time = TimeMatch[1];
                const url = UrlMatch[0];
                return {
                    title,
                    time,
                    url
                };
            } else {
                throw new Error("请完整复制");
            }
    }
}
